import {
  RebateProgress,
  RebateProgressFetcherQuery,
  RebateProgressFetcherQueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";

export const rebateProgressQuery = gql`
  query RebateProgressFetcher($filter: RebateProgressFilter!) {
    rebates {
      rebateProgress(filter: $filter) {
        rebateAgreement {
          name
          rebateAgreementNumber
        }
        criterias {
          name
          description
          rebateModelCode
        }
        goalIds
        goal {
          period
          rebateTermCode
          validFrom
          validTo
        }
        period
        displayedTarget
        usedTarget
        expectedVolume
        suggestedExpectedVolume
        achieved
        completionPercent
        isTopLevel
      }
    }
  }
`;

export const useRebateProgress = () => {
  const [loadRebateProgress, { loading, error, data }] = useLazyQuery<
    RebateProgressFetcherQuery,
    RebateProgressFetcherQueryVariables
  >(rebateProgressQuery);

  return {
    loadRebateProgress,
    loading,
    error,
    rebateProgress: (data?.rebates.rebateProgress ?? []) as RebateProgress[],
  };
};
